import { useLocalization } from '@/shared/i18n'

import { daysUntil, formatDay, formatFullDate, pluralizeDays } from './date'

const RELATIVE_HORIZON_DAYS = 60

export type DeadlineFormat = (deadline: string | undefined) => string | undefined

export function useDeadlineText(): DeadlineFormat {
  const { t, language } = useLocalization()

  return (deadline) => {
    if (!deadline) {
      return undefined
    }

    const days = daysUntil(deadline)

    if (days === undefined) {
      return deadline
    }

    if (days < 0) {
      return t('due.overdue', { days: pluralizeDays(days, language) })
    }

    if (days === 0) {
      return t('due.today')
    }

    if (days <= RELATIVE_HORIZON_DAYS) {
      return t('due.soon', {
        days: pluralizeDays(days, language),
        date: formatDay(deadline, language),
      })
    }

    return formatFullDate(deadline, language)
  }
}
